// El informe semanal (R4). Tres puertas al mismo informe, y la regla de quien lo ve vive en el
// servidor (`services/informe_semanal.es_lector`): aqui solo se pide.
import { api } from "./client";

// El alumno, el suyo.
export const getMiInforme = (semana) =>
  api.get("/family/informe", { params: { semana } }).then((r) => r.data);
// Quien paga el plan Familiar, el de un alumno que acepto su invitacion.
export const getInformeDeMiFamilia = (alumnoId, semana) =>
  api.get(`/family/informe/alumno/${encodeURIComponent(alumnoId)}`, { params: { semana } })
    .then((r) => r.data);
// La familia desde el enlace del correo, sin sesion.
export const getInformePorEnlace = (t, semana) =>
  api.get("/family/informe/enlace", { params: { t, semana } }).then((r) => r.data);
